import type { HTMLAttributes, FC } from 'react';

import { cn } from './cn.js';

export const Card: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...rest
}) => (
  <div
    className={cn(
      'rounded-lg border border-ink-200 bg-white shadow-sm',
      className,
    )}
    {...rest}
  />
);

export const CardHeader: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...rest
}) => (
  <div
    className={cn(
      'flex items-center justify-between border-b border-ink-150 px-[18px] py-3.5',
      className,
    )}
    {...rest}
  />
);

export const CardTitle: FC<HTMLAttributes<HTMLHeadingElement>> = ({
  className,
  children,
  ...rest
}) => (
  // children прокидываем явно, а не спредом: иначе линтер доступности не видит
  // содержимое заголовка и считает его пустым.
  <h3
    className={cn('m-0 text-sm font-semibold text-ink-900', className)}
    {...rest}
  >
    {children}
  </h3>
);

export const CardBody: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...rest
}) => <div className={cn('p-[18px]', className)} {...rest} />;
